import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SafariViewController } from '@ionic-native/safari-view-controller';

@Injectable()
export class BrowserServiceProvider {
	constructor(
		private inAppBrowser: InAppBrowser,
		private safariViewController: SafariViewController,
		private platform: Platform
	) {}

	openBrowser(url: string): void {
		if (this.platform.is('ios')) {
			this.openSafariViewController(url);
		} else if (this.platform.is('android')) {
			this.openSystemBrowser(url);
		} else {
			this.openInAppBrowser(url);
		}
	}

	private openSafariViewController(url: string): void {
		this.safariViewController.isAvailable().then((available: boolean) => {
			if (available) {
				this.safariViewController
					.show({
						url,
						hidden: false,
						animated: true,
						transition: 'curl',
						enterReaderModeIfAvailable: true,
						tintColor: '#22BAA1'
					})
					.subscribe(
						(result: any) => {
							if (result.event === 'opened') {
								console.log('Opened');
							} else if (result.event === 'loaded') {
								console.log('Loaded');
							} else if (result.event === 'closed') {
								console.log('Closed');
							}
						},
						(error: any) => console.error(error)
					);
			} else {
				// fallback for iOS 9.0 and lower
				this.openInAppBrowser(url);
			}
		});
	}

	private openSystemBrowser(url: string): void {
		this.inAppBrowser.create(url, '_system');
	}

	private openInAppBrowser(url: string): void {
		this.inAppBrowser.create(url, '_blank');
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./mobile/src/providers/browser-service/browser-service.ts